import React, { Component } from 'react'
import { NavLink } from 'react-router-dom'
import axios from '../../axios'
import Alert from 'react-s-alert'
import CustomModal from '../../components/CustomModal'
import qs from 'qs'
import Paging from '../../components/Paging'

class Lists extends Component {

    constructor() {
        super();
        this.state = {
            dataWali    : [],
            kelas_id     : 0,
            pageCount    : 0,
            currentPage  : 0,
            isLoading    : false,
            isModalShow  : false,
        }

        this.toggleModal              = this.toggleModal.bind(this)
        this.handleSubmitDeleteButton = this.handleSubmitDeleteButton.bind(this)
    }

    toggleModal() {
        this.setState({ isModalShow: ! this.state.isModalShow })
    }

    handleSubmitDeleteButton() {

        Alert.error("BELUM ADA APINYA");
        
        this.toggleModal()

        // axios({
        //     method: 'get',
        //     url: '/produk/deleteProduk/' + this.state.id_produk
        // })
        //     .then(response => {

        //         Alert.success("Data berhasil dihapus");
        //         this.loadData();
        //         this.toggleModal();

        //         return;
        //     })
        //     .catch(error => {
        //         console.log(error)
        //         this.setState({ isLoading: false })
        //         Alert.error("Gagal terhubung ke server!")
        //     })
    }

    handlePageClick(data) {

        let selected = data.selected; // zero based index

        this.setState({ currentPage: selected }, () => {
            this.loadData();
        });
    }

    loadData() {

        this.setState({ isLoading: true })

        const params = qs.stringify({
            page: this.state.currentPage + 1
        })
        
        axios({
            method: 'post',
            url: '/listwalikelas?'+params
        })
        .then((response) => {

            const result = response.data

            if (result.success === true) {
                
                this.setState({
                    dataWali: Object.values(result.data.data),
                    pageCount: result.data.last_page,
                    isLoading: false 
                })
            }
            else {
           
                Alert.error(result.message)
                this.setState({ isLoading: false })
            }      
        })
        .catch((error) => {
            console.log(error)
            this.setState({ isLoading: false })
            Alert.error("Gagal terhubung ke server!")
        })
    }

    componentDidMount() {
                
        this.loadData()        
    }

    render () {

        return (         
            <div className="col-sm-12">

                <CustomModal
                    isShow={this.state.isModalShow}
                    toggleModal={this.toggleModal}
                    handleSubmit={this.handleSubmitDeleteButton}
                    modalHeaderText="Hapus Data"
                    modalBodyText="Anda yakin ingin menghapus data ini?"
                    modalSubmitText="Ya" />

                <div className="card">
                    <div className="card-block">
                        <NavLink 
                            to={`${this.props.match.url}/addWali`} 
                            className="btn btn-primary"
                        >
                            Tambah Wali Kelas
                        </NavLink>
                    </div>
                </div>
                <div className="card">
                    <div className="card-header">
                        Data Wali Kelas
                    </div>
                    <div className="card-block">
                        {
                            this.state.isLoading ? "Memuat Data..." : (
                                this.state.dataWali.length === 0 ? "Data Kosong..." : (
                                    <div>
                                        <table className="table table-striped table-bordered animated fadeIn">
                                            <thead>
                                                <tr>
                                                    <th>Nama Wali</th>
                                                    <th>Nama Kelas</th>
                                                    <th>Tahun Ajar</th>
                                                    <th width="200">Opsi</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {                                                    
                                                    this.state.dataWali.map((item) => {
                                                        return (
                                                            <tr  key={item.wk_id}>
                                                                <td>{item.user_nama}</td>
                                                                <td>{item.kelas_nama}</td>
                                                                <td>{item.thn_ajar}</td>
                                                                <td>
                                                                    <NavLink to={`${this.props.match.url}/editWali/${item.wk_id}`} className="btn btn-secondary btn-sm">
                                                                        Edit
                                                                    </NavLink>
                                                                </td>                                                                                                                 
                                                            </tr>
                                                        )
                                                    })
                                                }
                                            </tbody>
                                        </table>   

                                        <Paging
                                            handlePageClick={this.handlePageClick.bind(this)}
                                            pageCount={this.state.pageCount}
                                            currentPage={this.state.currentPage}
                                        />
                                    </div>
                                )
                            )
                        }
                    </div>
                </div>
            </div>                   
        )
    }
}

export default Lists;



// WEBPACK FOOTER //
// ./src/views/Kelas/ListWali.js